/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface ContratFichierUploadDto
 */
export interface ContratFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof ContratFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierUploadDto
     */
    idcontratFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierUploadDto
     */
    idcontrat?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ContratFichierUploadDto
     */
    idtypeContratFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ContratFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the ContratFichierUploadDto interface.
 */
export function instanceOfContratFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratFichierUploadDtoFromJSON(json: any): ContratFichierUploadDto {
    return ContratFichierUploadDtoFromJSONTyped(json, false);
}

export function ContratFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idcontratFichier': !exists(json, 'idcontratFichier') ? undefined : json['idcontratFichier'],
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeContratFichier': !exists(json, 'idtypeContratFichier') ? undefined : json['idtypeContratFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function ContratFichierUploadDtoToJSON(value?: ContratFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idcontratFichier': value.idcontratFichier,
        'idcontrat': value.idcontrat,
        'idfichier': value.idfichier,
        'idtypeContratFichier': value.idtypeContratFichier,
        'fileName': value.fileName,
    };
}

